// -----------------------------------------------------------------------------
// Scripts for event modal
// -----------------------------------------------------------------------------

$('.schedule__event').on('click', function() {
  const modal = new bootstrap.Modal(document.getElementById('speakerModal'));
  const modalBody = $('#speakerModal').find('[data-modal-body]');
  const modalContent = $(this).find('[data-event-modal]').html();

  if(modalContent) {
    modalBody.html(modalContent);
    modal.toggle();
  }
});